/**
 * 主界面中心头部组件
 * 创建时间：2017-02-22
 *   创建人：zhanlz
 */
<template>
	<div class="row border-bottom">
			<nav class="navbar" role="navigation" style="margin-bottom: 0" :class="fixedNavClass">
				<div class="navbar-header">
					<button class="navbar-minimalize minimalize-styl-2 btn btn-primary " @click.stop="navbarmini"><i class="fa fa-bars"></i> </button>
				</div> 
				<ul class="nav navbar-top-links navbar-right" v-if="levv==2"> 
					<li @click="createRescueOrder" v-if="permission.indexOf('rescueServiceOrderList_addOrder') == -1">
						<a class="new_order">新建救援单</a>
					</li>
					<li class="dropdown hidden-xs picc_tip picc_tip_red" v-if="permission.indexOf('rescueServiceOrderList_orderType') == -1">
						<div>
							<em>待救援：</em> 
							<a class="right-sidebar-toggle count_info" aria-expanded="false" @click.stop = "getRescueList('',11,'')">
								  自动派单<span class="popup_digit embblink general">{{autoDispatchNo}}</span>
							</a>
							 
							<a class="right-sidebar-toggle count_info" aria-expanded="false" @click.stop="getList">
								  人工派单 
								<!--levv==2时表示待人保坐席派单-->
								<span class="popup_digit embblink" :class="[handDispatchNo===0?'general':'emergency1']" @click.stop="getRescueList('',12,'')">{{handDispatchNo}}</span> 
								<!--levv==2时显示待救援公司派单-->
								<span class="popup_digit popup_digit_bottom embblink" :class="[handDispatchNo2===0?'general':'emergency1']" @click.stop="getRescueList('',13,'')">{{handDispatchNo2}}</span>
							</a> 
							<a class="right-sidebar-toggle count_info" aria-expanded="false" @click.stop = "getRescueList(1,'',1)">
								  预约<span class="popup_digit embblink general">{{arrangeNo}}</span>
							</a>
							<a class="right-sidebar-toggle count_info" aria-expanded="false" @click.stop = "getRescueList(1,13,'',67)">
								派单超时<span class="popup_digit embblink general">{{dispatchTimeOutNo}}</span>
							</a>
						</div> 
					</li>
					<li class="dropdown hidden-xs picc_tip picc_tip_orange" v-if="permission.indexOf('rescueServiceOrderList_orderType') == -1">
						<div>
							<em>已接单：</em>
							<a class="right-sidebar-toggle count_info" aria-expanded="false" @click.stop = "getRescueList(2,65,'',65)">
								联系超时<span class="popup_digit embblink" :class="[noContactNo===0?'general':'emergency1']">{{noContactNo}}</span>
							</a>
							<a class="right-sidebar-toggle count_info" aria-expanded="false" @click.stop = "getRescueList('',21,'')">
								现场前往中<span class="popup_digit embblink">{{sceneHeadingNo}}</span>
							</a> 
							<a class="right-sidebar-toggle count_info" aria-expanded="false" @click.stop = "getRescueList('',23,'')">
								现场已抵达<span class="popup_digit embblink">{{sceneArrivedNo}}</span>
							</a>
							<a class="right-sidebar-toggle count_info" aria-expanded="false" @click.stop = "getRescueList(2,21,'',66)">
								  抵达超时<span class="popup_digit embblink">{{arriveTimeoutNo}}</span>
							</a>
						</div> 
					</li>
					<li class="dropdown hidden-xs  picc_tip picc_tip_green" v-if="permission.indexOf('rescueServiceOrderList_orderType') == -1">
						<div>
							<em>已完成：</em>
							<a class="right-sidebar-toggle count_info" aria-expanded="false" @click.stop = "getFinishedRescueList('',31)">
								  司机已完成<span class="popup_digit embblink">{{driverFinishedNo}}</span>
							</a>
							<a class="right-sidebar-toggle count_info" aria-expanded="false" @click.stop = "getFinishedRescueList('',32)">
								  客户已评价<span class="popup_digit embblink">{{customerReviewedNo}}</span>
							</a>
							<a class="right-sidebar-toggle count_info" aria-expanded="false" @click.stop = "getFinishedRescueList(4,'')">
								  已撤单<span class="popup_digit embblink">{{orderWithdrawedNo}}</span>
							</a>
						</div>
					</li> 
				</ul>
				<ul class="nav navbar-top-links navbar-right nav_company" v-if="levv==3"> 
					<li class="dropdown hidden-xs picc_tip picc_tip_red" v-if="permission.indexOf('rescueServiceOrderList_orderType') == -1">
						<div>
							<em>待救援：</em>  
							<a class="right-sidebar-toggle count_info" aria-expanded="false" @click.stop = "getRescueList('',13,'')">
								  人工派单
								  <!--levv==3时，仅仅显示待救援公司派单-->
								<span class="popup_digit embblink" :class="[handDispatchNo===0?'general':'emergency1']">{{handDispatchNo}}</span> 
							</a> 
						</div> 
					</li>
				</ul>
				<ul class="nav navbar-top-links navbar-right nav_company" v-if="levv==1">
					<li class="dropdown hidden-xs">
						<a style="color:rgb(0,122,180); paddingRight:30px;" class="right-sidebar-toggle count_info"  @click.stop="showMission">
							<i class="fa fa-calendar-check-o"></i>后台任务<!--<span class="popup_digit bgc_00 embblink">{{taskNum}}</span>-->
						</a>
					</li>
				</ul>
			</nav>  
			<audio src="../../assets/remindVoice.mp3" id='audioPlay'></audio>
            <audio src="../../assets/remindVoiceRB.mp3" id='audioPlayRB'></audio>
	</div>
</template>

<script>
  import {mapState} from 'vuex' 
  import toastr from 'assets/plugins/toastr/toastr.min.js'
  export default {
    name: 'ContentHeader',
    data() {
      return {
      	//	permission:this.$store.state.permission.permission["rescueServiceOrderLi"]?this.$store.state.permission.permission["rescueServiceOrderLi"]:[],
      		autoDispatchNo:0,
      		handDispatchNo:0, //levv=3是表示待救援公司派单，levv==2时，表示待人保坐席派单
      		handDispatchNo2:0,//levv==2时才显示，表示待救援公司派单
      		arrangeNo:0,
      		dispatchTimeOutNo:0, //派单超时
      		noContactNo:0,
      		sceneHeadingNo:0,
      		sceneArrivedNo:0,
      		arriveTimeoutNo:0,
      		driverFinishedNo:0,
      		customerReviewedNo:0,
      		orderWithdrawedNo:0,
      		refreshTimer:null,
      		remindAudio:null
      };
    },   
    beforeMount(){  
    	let groupId = this.$store.state.user.groupid
		if(this.levv!=1 && this.licenceId===2){
			this.getOrderNoByClass()
		} 
    	this.$nextTick(()=>{
    		toastr.options={
				"closeButton":true,
				"progressBar":true
			}
    	}) 
	},
    methods:{
		showMission(){//后台任务
			this.$store.dispatch('showMission',true)
		},
    	createRescueOrder(){
    		//打开新建救援单页面
			const obj = {
						name:'新建救援单', 
						id:'PageRescueServiceOrderEdit',
						route:'/indexhome/rescueServiceOrderEdit',
						No:'rescueServiceOrderEdit',
						params:{detailMode:0}
					}
					this.$router.push({path:'/indexhome/rescueServiceOrderEdit',query:obj.params});
					this.$store.dispatch('addTab',obj);	
    	},
    	getList(){
    		if(this.levv==3){
    			this.getRescueList('',13,'')
    		}else{
    			this.getRescueList('',12,'')
    		}
    	},
    	getRescueList(statusNo,stageNo,typeNo,timeOutNo){//打开救援单一览tab
    		//如果点击的是待人工派单，则停止声音提醒
    		/*if(stageNo === 13){
    			console.log('停止声音提醒')
    			this.remindVoiceStop()
    		}*/
    		// 跳转到救援单一览-根据救援阶段获取对应数据 
			this.goToRescueList()
				//传递参数过去
				let routeParam = {
					status:statusNo,
					stage:stageNo,
					type:typeNo,
					finishFlag:false,
					timeout:timeOutNo?timeOutNo:'',
					uni:new Date().getTime()
				}
				this.$store.dispatch('getOrderList',routeParam)
    	},
		getFinishedRescueList(statusNo,stageNo){
			// 跳转到救援单一览-根据救援阶段获取对应数据 
			this.goToRescueList()
			let routeParam = {
				status:statusNo,
				stage:stageNo,
				type:'',
				timeout:'',
				finishFlag:true,	
				uni:new Date().getTime()
			}
			this.$store.dispatch('getOrderList',routeParam)
		},
		goToRescueList(){
			const obj = {
				name:'救援单一览', 
				code:'rescueServiceOrderList',
				id:'PageRescueServiceOrderList',
				route:'/indexhome/rescueServiceOrderList',
				No:'rescueServiceOrderList'
			}
			this.$router.push(obj.route);
			this.$store.dispatch('addTab', obj); 
		},
    	getOrderNoByClass(){
    		const param = {//this.$store.state.user.groupid
    			companyId:this.$store.state.user.groupid
    		}   
    		this.getOrderNum(param)
    		const that = this;
    		clearTimeout(this.refreshTimer)
    		let getFunc = function(){
    			that.$http.get(process.env.API_INSURANCE_ROOT + '/rescue-api/orders/statistics/status',{params:param})
	    		.then(res=>{  
	    			let numArr = res.body.data
	    			that.setRescueCount(numArr,1)
	    			if(!that._isDestroyed){
	    				that.refreshTimer = setTimeout(getFunc,20000)
	    			}  
	    		},res=>{   
	    			if(!that._isDestroyed){
	    				that.refreshTimer = setTimeout(getFunc,20000)  
	    			}
	    			toastr.error(res.body.message) 
	    		})
	    		// .catch(res=>{   
	    		// 	if(!that._isDestroyed){
	    		// 		that.refreshTimer = setTimeout(getFunc,20000)  
	    		// 	}
	    		// 	toastr.error('请求异常') 
	    		// }) 
    		}  
    		this.refreshTimer = setTimeout(getFunc,20000) 
    	},
    	getOrderNum(param){
    		this.$http.get(process.env.API_INSURANCE_ROOT + '/rescue-api/orders/statistics/status',{params:param})
    		.then(res=>{   
    			let numArr = res.body.data
    			this.setRescueCount(numArr,0)
    		},res=>{
    			toastr.error(res.body.message) 
    		})
    		.catch(res=>{   
    			toastr.error('请求异常') 
    		}) 
    	},
    	setRescueCount(numArr,type){
    	//	console.log('type' + type)
    		if(this.levv==3){
    		//	console.log('救援公司' + this.handDispatchNo)
    		//	console.log(numArr[11].waitCompanyDispatchCount)
    			/*if(this.handDispatchNo > numArr[11].waitCompanyDispatchCount){
    				console.log('救援公司停止声音提醒')
    				this.remindVoiceStop()
    			}*/
    			if(this.handDispatchNo < numArr[11].waitCompanyDispatchCount && type===1){
    			//	console.log('救援公司开始声音提醒')
    				this.remindVoiceStart()
    			}
    		}else if(this.levv==2){
                if(this.handDispatchNo < numArr[10].waitAdminDispatchCount && type===1){
    			//	console.log('救援公司开始声音提醒')
                    // this.remindVoiceStart()
                    let audio = document.getElementById('audioPlayRB')
                    audio.play()
    			}
            }
    		//待接单-自动派单
			this.autoDispatchNo = numArr[0].autoSend 
			//待接单-人工派单
			if(this.levv==3){
				this.handDispatchNo = numArr[11].waitCompanyDispatchCount//levv=3是表示待救援公司派单
			}else{
				this.handDispatchNo = numArr[10].waitAdminDispatchCount//levv==2时，表示待人保坐席派单
				this.handDispatchNo2 = numArr[11].waitCompanyDispatchCount//levv==2时才显示，表示待救援公司派单
			} 
			//预约
    		this.arrangeNo = numArr[9].appoint
    		//派单超时
    		this.dispatchTimeOutNo = numArr[12].diapatchTimeout
			//已接单-接单未联系
		//	this.noContactNo = numArr[7].noConnection
			//已接单-联系超时
			this.noContactNo = numArr[7].contactTimeout
			//已接单-现场前往中
			this.sceneHeadingNo = numArr[2].goingList
			//已接单-现场已抵达
			this.sceneArrivedNo = numArr[3].siteArrived 
			//已接单-抵达超时
			this.arriveTimeoutNo = numArr[8].arriveTimeout
			//已完成-司机已完成
			this.driverFinishedNo = numArr[4].driverFinish 
			//已完成-客户已评价
			this.customerReviewedNo = numArr[5].evaluate 
			//已完成-已撤单
			this.orderWithdrawedNo = numArr[6].cancel  
    	},
		rightsidebar: function() {
			this.$store.dispatch('rightsidebar');
		},
		navbarmini: function() {
			$("body").toggleClass("mini-navbar"); 
		//	let miniNav = $("body").hasClass("mini-navbar") 
		//	this.$store.dispatch('toggleNavBar',miniNav)
		},
		//声音提醒响起来-----
		remindVoiceStart(){
		//	console.log('提醒模式' + this.voiceMode)
		//	console.log('提醒次数' + this.remindCount) 
			this.remindAudio = document.getElementById( "audioPlay" );
			this.remindAudio.play()
		},
		//声音提醒停下来-----
		remindVoiceStop(){
			this.remindAudio.pause()
		}
	},
    computed:{ 
    	permission(){
    		return this.$store.state.permission.permission["rescueServiceOrderLi"]?this.$store.state.permission.permission["rescueServiceOrderLi"]:[]
    	},
    	fixedNavClass: function () {
    		return {
			      'navbar-static-top': !this.$store.state.global.fixednav,
			      'navbar-fixed-top': this.$store.state.global.fixednav
			    }
    	},
    	levv(){
    		return this.$store.state.user.levv
		},
		licenceId(){
			return this.$store.state.user.licenceId
		}
    },
    beforeDestroy(){ 
    	clearTimeout(this.refreshTimer)
    	this.refreshTimer = null  
    }
  };
  function SmoothlyMenu() {
    if (!$('body').hasClass('mini-navbar')) {
        $('#side-menu').hide();
        setTimeout(
            function () {
                $('#side-menu').fadeIn(500);
            }, 100);
    } else if ($('body').hasClass('fixed-sidebar')) {
        $('#side-menu').hide();
        setTimeout(
            function () {
                $('#side-menu').fadeIn(500);
            }, 300);
    } else {
        $('#side-menu').removeAttr('style');
    }
}
</script>
<style scoped lang="scss">
	.bgc_00{
		background-color:rgb(0,122,180)
	}
	
	/*.general{
		display:none;
	}*/
	.emergency1{
		-webkit-animation: twinkle 1s infinite ease-in-out;
		-moz-animation: twinkle 1s infinite ease-in-out; 
		-o-animation:twinkle 1s infinite ease-in-out;
		animation:twinkle 1s infinite ease-in-out;
	}

	@-webkit-keyframes twinkle{ 
		 0 { transform:scale(1); opacity:0; }
		20%{transform:scale(1.2); opacity:1;  }
	    40%{transform:scale(1.1); opacity:0.5;  }
		60%{transform:scale(1.2); opacity:1;  }
		80%{transform:scale(1) ease; opacity:0;  }
	} 
	@-moz-keyframes twinkle{ 
		0 { transform:scale(1); opacity:0; }
		20%{transform:scale(1.2); opacity:1;  }
	    40%{transform:scale(1.1); opacity:0.5;  }
		60%{transform:scale(1.2); opacity:1;  }
		80%{transform:scale(1) ease; opacity:0;  }
	}
	@-o-keyframes twinkle{ 
		0{ transform:scale(1); opacity:0;}
		20%{transform:scale(1.2); opacity:1;  }
	    40%{transform:scale(1.1); opacity:0.5;  }
		60%{transform:scale(1.2); opacity:1;  }
		80%{transform:scale(1) ease; opacity:0;  }
	}  
	@keyframes twinkle{ 
		0 { transform:scale(1); opacity:0; }
		20%{transform:scale(1.2); opacity:1;  }
	    40%{transform:scale(1.1); opacity:0.5;  }
		60%{transform:scale(1.2); opacity:1;  }
		80%{transform:scale(1) ease; opacity:0;  }
	}
	.picc_tip a:hover{
		opacity:0.7;
	}
	.picc_tip a:active{
		color:#000!important;
	}
	.popup_digit_bottom{
		top:18px !important;
		background-color:#166dcf !important;
	}
 
</style>


// WEBPACK FOOTER //
// ContentHeader.vue?814d8fa8